import { CardMembership, MappableModel, Organization } from '../../models'

export class MembershipItem extends MappableModel {
  public membership: CardMembership
  public organization: Organization
}
